/**
 * Looks for modules in the page and initialize them if they are ready.
 * @param {HTMLElement} $root [optional] Parent root to look for modules. If not given, uses the document.
 */
function initializeModules($root) {
  const jsModuleClass = 'js-module';
  var $parentNode = $root || document;
  var $modules = $parentNode.getElementsByClassName(jsModuleClass);
  var Acr = window.Acr || {};

  Acr.Modules = {};
  for (var modulesIndex = 0; modulesIndex < $modules.length; modulesIndex++) {
    var $module = $modules[modulesIndex];

    if ($module.dataset.moduleStarted !== 'true') {
      var loadModule = $module.dataset.moduleLoad;
      if (loadModule !== 'false') {
        var moduleName = $module.dataset.module;
        var moduleId = (modulesIndex + 1).toString();

        $module.dataset.moduleStarted = 'true';
        $module.dataset.moduleId = moduleId;
        if (moduleName) {
          var newModule = new Acr[moduleName]($module);
          if (newModule.init) {
            newModule.init($module);
            Acr.Modules[moduleId] = newModule;
          }
        }
      }
    }
  }
}
